const SFCC_REFERER_LINK_KEY = 'SFCCRefererLink';

export const getSFCCRefererLink = (): string | undefined => {
  return sessionStorage.getItem(SFCC_REFERER_LINK_KEY) || undefined;
};

export const saveSFCCRefererLink = (refererLink: string): void => {
  sessionStorage.setItem(SFCC_REFERER_LINK_KEY, refererLink);
};

export const removeSFCCRefererLink = (): void => {
  sessionStorage.removeItem(SFCC_REFERER_LINK_KEY);
};
